export default __webpack_public_path__ + "media/suspicious_login_attempt/ip-4a0b1a5d.png";